// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"ukb1PnF6","main":"ECxXKGAM","notFoundSection":"g9jEIkbs","title":"XYkmvpeN","description":"w2TTArsH","animationContainer":"Ckk3u3Fh"};